import React from "react";
import Home from "./pages/LearningPath/Home";
import Play from "./pages/LearningPath/Play";
import Event from "./pages/event";
import FinebiHome from "./pages/Finebi_basiclearning/FinebiHome";
import FinebiPlay from "./pages/Finebi_basiclearning/FinebiPlay";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import NotFound from "./routes/nofound";
import { UseGaTracker } from "./components";
const App = () => {
  UseGaTracker();
  return (
    <Switch>
      <Route exact path="/">
        <h2>总视频页面</h2>
      </Route>
      <Route path="/basiclearning/about">
        <h2>about</h2>
      </Route>

      <Route path="/basiclearning/:id">
        <Play />
        {/* <h2>basiclearning/:id</h2> */}
      </Route>
      <Route path="/basiclearning">
        <Home />
        {/* <h2>basiclearning</h2> */}
      </Route>
      <Route path="/events">
        <Event />
      </Route>
      <Route path="/finebi_basiclearning/:id">
        <FinebiPlay />
      </Route>
      <Route path="/finebi_basiclearning">
        <FinebiHome />
        {/* <h2>finebi_basiclearning/:id</h2> */}
      </Route>

      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
};

export default App;
